export enum HomeScreenNames {
  MAIN = 'home-nav',
  HOME = 'home',
  TABS = 'tabs',
  DRAWER = 'drawer-nav',
}
